export default __webpack_public_path__ + "static/media/vip-1.26aabc70.webp";